import { render, staticRenderFns } from "./ProjectBookingPropEdit.vue?vue&type=template&id=6e5d4c05&"
import script from "./ProjectBookingPropEdit.vue?vue&type=script&lang=js&"
export * from "./ProjectBookingPropEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports